import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { usePermissions } from '../App';
import { generateInvoiceFromWip } from '../api';

export default function UnbilledGenerateButton({ clientId, timeEntryIds = [], expenseEntryIds = [], feeEntryIds = [], authAxios, onInvoiceGenerated, showToast }) {
  const permissions = usePermissions();
  const disabled = !permissions?.canContributeBilling;

  const handleClick = async () => {
    if (disabled) {
      showToast('You do not have permission to generate invoices from unbilled work.', 'warning');
      return;
    }
    try {
      if (!clientId) {
        showToast('Unable to determine client. Please refresh and try again.', 'danger');
        return;
      }
      // Prefer explicit IDs when provided, otherwise fall back to client_id
      const payload = {};
      if (Array.isArray(timeEntryIds) && timeEntryIds.length) payload.time_entry_ids = timeEntryIds;
      if (Array.isArray(expenseEntryIds) && expenseEntryIds.length) payload.expense_entry_ids = expenseEntryIds;
      if (Array.isArray(feeEntryIds) && feeEntryIds.length) payload.fee_entry_ids = feeEntryIds;
      
      // Validate that we have at least some entries to bill
      if (!payload.time_entry_ids?.length && !payload.expense_entry_ids?.length && !payload.fee_entry_ids?.length) {
        showToast('No unbilled entries found for this client.', 'warning');
        return;
      }
      
      // Always include client_id for context (backend may accept it)
      payload.client_id = clientId;
      const resp = await generateInvoiceFromWip(authAxios, payload);
      // Expect server to return created invoice data
      console.log('Generated invoice response:', resp);
      if (resp && resp.id) {
        showToast(`Invoice ${resp.invoice_number || resp.id} created from unbilled items`, 'success');
        console.log('Invoice created with ID:', resp.id, 'Firm:', resp.firm, 'Client:', resp.client);
        
        // Call the parent's refresh handler
        if (onInvoiceGenerated) {
          await onInvoiceGenerated();
        }
        
        // open the invoice details if UI listens for this event
        try {
          window.dispatchEvent(new CustomEvent('open-resource-detail', { detail: { tab: 'billing', id: resp.id } }));
        } catch (e) {
          // ignore if CustomEvent not supported
        }
      } else {
        console.warn('Unexpected response from generate_from_wip:', resp);
        showToast('Invoice generation returned unexpected response', 'warning');
      }
    } catch (e) {
      console.error('Failed to generate invoice from WIP', e.response || e);
      const msg = e.response?.data?.detail || e.response?.data || 'Failed to generate invoice';
      showToast(String(msg), 'danger');
    }
  };

  return (
    <Tippy content={disabled ? 'You do not have permission to generate invoices from unbilled work.' : ''} disabled={!disabled}>
      <div>
        <button
          className={`px-3 py-1.5 rounded-md text-sm ${disabled ? 'bg-gray-300 text-gray-600 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
          onClick={handleClick}
        >
          Generate Invoice
        </button>
      </div>
    </Tippy>
  );
}
